module.exports = __webpack_public_path__ + "img/05.be3edbd8.jpg";